import * as types from './actionTypes.gitHubIntegration';
import initialState from '../initialState';

const initialStateObj = {
    ...initialState.gitHubIntegration
};

export default function gitHubIntegrationReducer(state = initialStateObj,
    {
        type,
        gitUserProject,
        hasChangesToPull,
        hasChangesToPush,
        path,
        repoUrl,
        hasGithubToken,
        hasGithubAccess,
        repositories,
        branches,
        files,
        githubLogin,
        remoteFiles,
        repoPermissions,
        organizations,
        githubDeployId
    }) {
    switch (type) {

        case types.GET_GITHUB_PROJECT_SETTINGS_OK:
            return {
                ...state,
                ...{
                    gitUserProject,
                    path,
                    repoUrl,
                    githubLogin,
                    repoPermissions,
                    githubDeployId
                }
            };

        case types.GITHUB_CREDENTIALS_ERR:
            return {
                ...state,
                ...{
                    hasGithubToken,
                    hasGithubAccess,
                }
            };

        case types.ADD_FILES_TO_PROJECT_REQ:
        case types.PULL_PROJECT_FROM_GITHUB_REQ:
            return {
                ...state,
                ...{
                    isPulling: true,
                }
            };

        case types.PULL_PROJECT_FROM_GITHUB_OK:
        case types.PULL_PROJECT_FROM_GITHUB_ERR:
            return {
                ...state,
                ...{
                    isPulling: false,
                }
            };

        case types.PUSH_PROJECT_TO_GITHUB_REQ:
        case types.CHECK_PUSH_STATUS_BEFORE_PUSH_REQ:
            return {
                ...state,
                ...{
                    isPushing: true,
                }
            };

        case types.PUSH_PROJECT_TO_GITHUB_OK:
        case types.PUSH_PROJECT_TO_GITHUB_ERR:
        case types.CHECK_PUSH_STATUS_BEFORE_PUSH_OK:
            return {
                ...state,
                ...{
                    isPushing: false,
                }
            };

        case types.GITHUB_REQUEST_PROCESSING_REQ:
            return {
                ...state,
                ...{
                    isRequestProcessing: true,
                }
            };

        case types.GITHUB_REQUEST_PROCESSING_OK:
        case types.GITHUB_REQUEST_PROCESSING_ERR:
            return {
                ...state,
                ...{
                    isRequestProcessing: false,
                }
            };


        case types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK:
            return {
                ...state,
                ...{
                    hasChangesToPull,
                }
            };

        case types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK:
            return {
                ...state,
                ...{
                    hasChangesToPush,
                }
            };

        case types.RESET_GITHUB_PROJECT_DATA_REQ:
            return {
                ...state,
                ...{
                    gitUserProject: null,
                }
            };

        case types.GET_REPOSITORIES_BY_USER_REQ:
            return {
                ...state,
                ...{
                    branches: null,
                    files: null,
                }
            };

        case types.GET_ORGANIZATIONS_BY_USER_OK:
            return {
                ...state,
                ...{
                    organizations: [
                        { id: 'personal', login: 'Personal' },
                        ...organizations
                    ],
                }
            };

        case types.GET_REPOSITORIES_BY_USER_OK:
            return {
                ...state,
                ...{
                    repositories,
                }
            };

        case types.GET_BRANCHES_BY_REPOSITORY_REQ:
            return {
                ...state,
                ...{
                    files: null,
                }
            };

        case types.GET_BRANCHES_BY_REPOSITORY_OK:
            return {
                ...state,
                ...{
                    branches,
                }
            };

        case types.GET_FILES_BY_BRANCH_OK:
            return {
                ...state,
                ...{
                    files,
                }
            };

        case types.RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_OK:
            return {
                ...state,
                ...{
                    branches: null,
                    files: null,
                }
            };

        case types.GET_REMOTE_FILES_OK:
            return {
                ...state,
                ...{
                    remoteFiles,
                }
            };

        case types.REVOKE_GITHUB_ACCESS_OK:
            return {
                ...state,
                ...initialState.gitHubIntegration
            };

        default:
            return state;
    }
}
